import { render, staticRenderFns } from "./kng-releated.vue?vue&type=template&id=f4ab70c0"
import script from "./kng-releated.vue?vue&type=script&lang=js"
export * from "./kng-releated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports